import * as methods from '../methods';
import { Resource } from '../Resource';
const rootPath = 'externalConnectionsErrors';
export default Resource((requesterBuilder, { getCtx }) => {
    const host = getCtx().hosts.ts;
    const get = (query) => methods.get({
        host,
        requesterBuilder,
        rootPath,
        fromRaw: (message) => message,
        params: {
            query
        }
    })();
    return {
        get
    };
});
